export default __webpack_public_path__ + "static/media/Place.48df9eb4.svg";